<template>
    <div class="micro-app-cci" >
      <micro-app
          v-if="storeInfo && storeInfo.user && storeInfo.user.userCode"
          name='app-cci'
          :url="config.microCciUrl"
          baseroute='/app-cci'
          :data='storeInfo'
          keep-alive
          iframe>
      </micro-app>
    </div>
  </template>
<script>
import config from '@/config/user.env';
import microApp from '@micro-zoe/micro-app';
import { mapState, mapGetters } from 'vuex';
import { getSupplierContactsInfos } from '../../index/api/user.js';

export default {
    data() {
        return {
            config,
            storeInfo: {},
            currentContactsMobile: null
        };
    },
    computed: {
        ...mapState(['contactsMobile']),
        ...mapGetters(['user', 'authority', 'currentTenant', 'appId', 'tenantInfo', 'appList', 'applicationCode', 'supplier', 'btnPermissions'])
    },
    async mounted() {
        if (!this.contactsMobile) {
            await this.getMobile();
        }
        const {
            user,
            authority,
            currentTenant,
            appId,
            tenantInfo,
            appList,
            applicationCode,
            supplier,
            btnPermissions,
            contactsMobile,
            currentContactsMobile } = this;
        this.storeInfo = {
            user,
            authority: [
                ...authority,
                {
                    resourceCode: 'RE5590595790655488',
                    frontUrl: '/mod/service/problemTmsDetail',
                    resourceName: '问题件详情',
                    resourceType: 2
                }
            ],
            currentTenant,
            appId,
            tenantInfo,
            appList,
            applicationCode,
            supplier,
            btnPermissions,
            contactsMobile: contactsMobile || currentContactsMobile
        };
    },
    methods: {
        getMobile() {
            return getSupplierContactsInfos({ userCode: this.user.userCode }).then(res => {
                if (res && +res.code === 0 && res.data.list.length) {
                    this.currentContactsMobile = res.data.list[0].contactsMobile;
                }
            }).catch(err => {});
        }
    },
    watch: {
        $route(val) {
            microApp.setData('app-cci', { path: val.path });
        }
    }
};
</script>
<style lang="less">
.micro-app-cci {
    height: calc(100vh - 60px);
    padding: 10px;
    micro-app[name="app-cci"] {
        width: 100%;
        height: 100%;
        .font-blue,
        .el-button--text
        ,.to-back-btn {
            color: #00bcbf !important;
        }
        .is-active .el-radio-button__inner,
        .search-btn.el-button--primary,
        .problem-footer-btn .el-button--primary {
            background-color: #00bcbf !important;
            border-color: #00bcbf !important;
        }
        .to-back-btn {
            border: 2px solid #00bcbf !important;
        }
        .is-active .el-radio-button__inner {
            box-shadow: -1px 0 0 0 #00bcbf !important;
        }
        .el-pagination .el-pager li.active{
            background-color: #00bcbf !important;
        }
    }
}
</style>
